
export default {
  name: 'EventCardSkeleton'
}
